import { render } from "./vdepartment.vue?vue&type=template&id=487f2ea3&scoped=true"
import script from "./vdepartment.vue?vue&type=script&lang=js"
export * from "./vdepartment.vue?vue&type=script&lang=js"

import "./vdepartment.vue?vue&type=style&index=0&id=487f2ea3&scoped=true&lang=css"

import exportComponent from "/var/jenkins_home/workspace/生产环境租户后台rent.syinba.com/jsvueweb/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-487f2ea3"]])

export default __exports__